import React from "react";

export default function Stacked_Column_Charts() {
  return <div>Excel_Stacked_Column_Charts</div>;
}
